import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    supportedLngs: ['en', 'fr', 'ar'],
    fallbackLng: 'fr',
    lng: 'fr',
    debug: true,
    // Options for language detector
    detection: {
      order: ['localStorage', 'cookie', 'path', 'htmlTag', 'subdomain'],
      caches: ['localStorage', 'cookie'],
      // Set French as default if no language is detected
      defaultLanguage: 'fr',
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false, // Prevents useTranslation from suspending during synchronous renders
    },
  }).then(() => {
    // Apply RTL direction immediately on load based on detected/stored language
    const lang = i18n.language || 'fr';
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  });

export default i18n;
